function transformInitialPublicOfferChange(data) {
  const {
    Isin: instrumentIsin,
    Start: startTime,
    End: endTime,
    Qty: maximumOrderQuantity,
    MinPrice: minimumOrderPrice,
    MaxPrice: maximumOrderPrice,
    Action: action,
  } = data;

  return {
    instrumentIsin,
    startTime,
    endTime,
    maximumOrderQuantity,
    minimumOrderPrice,
    maximumOrderPrice,
    action,
  };
}

export { transformInitialPublicOfferChange };
